
import { NhtsaResponse } from "@/types/vehicle/vehicle-base";
import { DataOneUtils } from "../dataone/utils";

interface VehicleInfoProps {
  data: NhtsaResponse;
  dataOneData?: any; // DataOne data structure
}

export const VehicleInfo = ({ data, dataOneData }: VehicleInfoProps) => {
  // Use the DataOneUtils helper to extract vehicle info from DataOne data
  const dataOneVehicleInfo = dataOneData ? DataOneUtils.getVehicleInfo(dataOneData) : null;
  
  const getVehicleInfo = () => {
    // If DataOne data is available and we have valid vehicle info, use it
    if (dataOneVehicleInfo) {
      return {
        make: dataOneVehicleInfo.make || "N/A",
        model: dataOneVehicleInfo.model || "N/A",
        trim: dataOneVehicleInfo.trim || "N/A",
        year: dataOneVehicleInfo.year || "N/A"
      };
    }
    
    // Fallback to NHTSA data if DataOne data is not available
    if (!data || !Array.isArray(data?.Results)) {
      return { make: "N/A", model: "N/A", trim: "N/A", year: "N/A" };
    }

    const vehicleData = data.Results[0];
    
    return {
      make: vehicleData.Make || "N/A",
      model: vehicleData.Model || "N/A",
      trim: vehicleData.Trim || "N/A",
      year: vehicleData.ModelYear || "N/A"
    };
  };

  const { make, model, trim, year } = getVehicleInfo();

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold">Vehicle Information</h3>
      <div className="grid grid-cols-4 gap-4">
        <div>
          <p className="text-sm text-gray-500">Make</p>
          <p className="font-medium">{make}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Model</p>
          <p className="font-medium">{model}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Trim</p>
          <p className="font-medium">{trim}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Year</p>
          <p className="font-medium">{year}</p>
        </div>
      </div>
    </div>
  );
};
